import { IconPathData } from "@fortawesome/fontawesome-common-types";

interface AskCaitButtonTemplateParams {
  className: string
  path: string | IconPathData
}

export function getAskCaitButtonHtml({ className, path }: AskCaitButtonTemplateParams): string {
  return (
    '<svg aria-hidden="true" focusable="false" ' +
        `class="svg-inline--fa ${className}" role="img" ` +
        'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">' +
        `<path fill="currentColor" d="${path}"></path></svg>` +
        '<span class="cait-button-label">AI Assist</span>'
  );
}
